import React from 'react';

import { InboxPayrollProvider } from 'src/components/inbox';

export const InboxPagePayrollProvider: React.FC = () => {
  return <InboxPayrollProvider />;
};
